import React from 'react'

const CategoryBox = props => {
  const { children = '', className = '' } = props

  return <div className={`wcategory-box ${className ? ` ${className}` : ''}`}>{children}</div>
}

export default CategoryBox
